var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy',{attrs:{"options":{
    threshold: 0.5
  },"min-height":"80","transition":"fade-transition"},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('v-avatar',{staticClass:"mx-auto",attrs:{"width":"100%","height":`undefined`,"max-width":"100","tile":""}},[(_vm.image)?_c('img',{attrs:{"alt":"Avatar","src":_vm.image}}):_c('v-icon',{attrs:{"large":"","color":"gray darken-2"}},[_vm._v("mdi-camera-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }